import { RegisterModule } from '@/typings/common'
import {
  NotificationBanner as Data,
  NotificationBannerCollection as Collection,
} from '@/typings/api/NotificationBanner'
import { NotificationsBannersApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import {
  NotificationBannersAdapter as Adapter,
} from './NotificationBannersAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as notificationBannersStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
